<template lang="pug">
  .component.component-backoffice-common.cost.type(v-if="item")
    .card( v-if="$is('listing')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="3")
          div(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              common-cost-type-button(:item="item" @itemUpdated="$emit('itemUpdated')")
          .field-value(slot="n1") CCT{{item.id}}
          .field-value(slot="n1") {{item.name}}
          .field-value(slot="n2") Description
          .field-value(slot="n2") {{item.description}}

</template>
<script type="text/babel">
  import CardN from 'components/structure/CardN'
  import Dropdown from '../structure/foundation/Dropdown'
  import CommonCostTypeButton from '../structure/ui/actions/CommonCostTypeButton'

  export default {
    name: 'CommonCostType',
    components: {
      CommonCostTypeButton,
      Dropdown,
      CardN,
    },
    data() {
      return {}
    },
    created() {
    },
    methods: {},
    computed: {},
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// CommonCostType.vue?4e60702b